import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ListingPage from "../pages/listing/page";
import ListingDetailPage from "../pages/listing-detail/page";
import IlanVerPage from "../pages/ilan-ver/page";
import LoginPage from "../pages/auth/login/page";
import RegisterPage from "../pages/auth/register/page";
import PanelimPage from "../pages/panelim/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ilanlar",
    element: <ListingPage />,
  },
  {
    path: "/ilan/:id",
    element: <ListingDetailPage />,
  },
  {
    path: "/ilan-ver",
    element: <IlanVerPage />,
  },
  {
    path: "/panelim",
    element: <PanelimPage />,
  },
  {
    path: "/giris",
    element: <LoginPage />,
  },
  {
    path: "/kayit",
    element: <RegisterPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
